import { Action } from '@/_core/fluxstore/types';
import { StorymapState } from '../../types';
import { useStorymapStore } from '../../useModule';

const { registerReducer } = useStorymapStore();

export class ClearTrackingFilters extends Action<StorymapState> {
    public static ACTION_TYPE = 'ClearTrackingFilters';

    public constructor() {
        super(ClearTrackingFilters.ACTION_TYPE);
    }
}

const reducer = (state: StorymapState): void => {
    state.trackingViewState.filterActivityIds = [];
    state.trackingViewState.filterTaskIds = [];
};

//@ts-ignore
registerReducer(ClearTrackingFilters.ACTION_TYPE, reducer);
